module.exports = __webpack_public_path__ + "static/media/stop-icon-finish.bc5ab5fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/stop-icon-finish.svg
// module id = 652
// module chunks = 0